export const userCredentials = {
  username: "",
  password: "",
  phone_number: "",
};

type TOktaLoginInfo = {
  username: string;
  password: string;
  phone_number?: string;
};

export const setUserCredentials = ({
  username,
  password,
  phone_number,
}: TOktaLoginInfo) => {
  userCredentials.username = username;
  userCredentials.password = password;
  userCredentials.phone_number = phone_number;
};
